module.exports = __webpack_public_path__ + "assets/img/footer.3e03caab8309472c26e77959427abe62.svg";